import { Button, Form, Input, Row, Space } from 'antd';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { onChangeCommaSeperator } from '../../AppUtil/AppUtil';
import Loader from '../../Component/Common/Loader';
import ServiceChargeService from '../../Service/ServiceChargeService';
import { toastError } from '../../SweetAlertUtil/util';

function AddForm({ setServiceCharge = () => {} }) {
	const [state, setState] = useState({ isLoading: false });
	const [max, setMax] = useState(null);
	const [price, setPrice] = useState(null);

	const isFloat = n => {
		return Number(n) === n && n % 1 !== 0;
	};

	const handleSubmit = async e => {
		e.preventDefault();
		setState({ isLoading: true });

		if (isFloat(max) || isFloat(price)) {
			toastError('Invalid input with decimal');
			setState({ isLoading: false });
			return;
		}

		const obj = {
			max: typeof max === 'string' ? +max.replace(/,/g, '') : max,
			price: typeof price === 'string' ? +price.replace(/,/g, '') : price
		};

		try {
			const response = await ServiceChargeService.add(obj);

			if (response?.status) {
				setState({ isLoading: false });

				toastSuccess(response.data.message);
				setServiceCharge();
			} else {
				setState({ isLoading: false });
				toastError(response.data);
			}
			setPrice(null);
			setMax(null);
		} catch (error) {
			setState({ isLoading: false });
			setPrice(null);
			setMax(null);
			toastError(error.message);
		}
	};

	const toastSuccess = msg => {
		Swal.fire({
			title: 'Success',
			animation: false,
			text: msg,
			icon: 'success',
			confirmButtonText: 'Okay',
			customClass: 'otp_message_success'
		});
	};

	return (
		<>
			<div className="addform">
				<form onSubmit={handleSubmit}>
					<Row>
						<Space>
							<Form.Item label="Max">
								<Input
									name="max"
									className="bold-important"
									onChange={event => {
										const value = onChangeCommaSeperator(event.target.value);
										setMax(value);
									}}
									placeholder="input max"
									type="text"
									value={max}
								/>
							</Form.Item>
							<Form.Item label="Price">
								<Input
									className="bold-important"
									name="price"
									onChange={event => {
										const value = onChangeCommaSeperator(event.target.value);
										setPrice(value);
									}}
									placeholder="input price"
									type="text"
									value={price}
								/>
							</Form.Item>
						</Space>

						<Form.Item style={{ marginLeft: '10px' }}>
							<Button danger htmlType="submit" type="primary">
								Add
							</Button>
						</Form.Item>
					</Row>
				</form>
			</div>
			{state.isLoading ? <Loader /> : null}
		</>
	);
}
export default AddForm;
